module.exports = __webpack_public_path__ + "img/logo-peace-dark-beta.efcc633b.jpg";